module.exports = __webpack_public_path__ + "static/media/autour.aaace0d9.webp";